(function () {
  'use strict';
  if (window.KWH) return;
  window.KWH = true;

  var doc = document, html = doc.documentElement;
  var ON = 'is-on';
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cart = null, fmt = null, toastTimer = null, opener = null;
  var heroPast = false, endReached = false, observers = [], polls = [], seq = 0, downOnBackdrop = false;

  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function layer(kind) { return $('[data-kwh-layer="' + kind + '"]'); }
  function fill(text, map) {
    return String(text || '').replace(/\[(\w+)\]/g, function (all, k) { return k in map ? map[k] : all; });
  }
  function money(cents) {
    if (!fmt) {
      var src = $('[data-kwh-currency]');
      try {
        fmt = new Intl.NumberFormat((src && src.getAttribute('data-kwh-locale')) || 'en', { style: 'currency', currency: (src && src.getAttribute('data-kwh-currency')) || 'USD' });
      } catch (e) {
        fmt = { format: function (n) { return '$' + n.toFixed(2); } };
      }
    }
    return fmt.format(cents / 100);
  }
  function request(path, body) {
    var opts = { headers: { Accept: 'application/json' }, credentials: 'same-origin' };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(base + path, opts).then(function (r) {
      return r.json().then(function (j) { return j; }, function () { return null; }).then(function (j) {
        if (!r.ok || !j) throw { shop: !!(j && j.status), description: j && (j.description || j.message) };
        return j;
      });
    }, function () { throw { shop: false }; });
  }

  function toastHost() {
    var t = $('[data-kwh-toast]');
    if (t) return t;
    var host = doc.createElement('div');
    host.className = 'kwh kwh-layer';
    host.innerHTML = '<div class="kwh-toast" data-kwh-toast role="status" aria-live="polite"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20 6L9 17l-5-5"/></svg><span></span></div>';
    doc.body.appendChild(host);
    return $('[data-kwh-toast]', host);
  }
  function toast(message) {
    if (!message) return;
    var t = toastHost();
    $('span', t).textContent = message;
    t.classList.add(ON);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove(ON); }, 2800);
  }
  function flash(btn, label) {
    if (!btn || !label) return;
    if (!btn.hasAttribute('data-kwh-label')) btn.setAttribute('data-kwh-label', btn.textContent);
    btn.classList.add('is-added');
    btn.textContent = label;
    clearTimeout(btn.kwhTimer);
    btn.kwhTimer = setTimeout(function () {
      if (!btn.isConnected) return;
      btn.classList.remove('is-added');
      btn.textContent = btn.getAttribute('data-kwh-label');
    }, 1400);
  }

  function modal() { return $('[data-kwh-modal]'); }
  function modalOpen() { var m = modal(); return !!m && m.classList.contains(ON); }
  function setTab(name, focus) {
    var m = modal();
    if (!m) return;
    $$('[data-kwh-tab]', m).forEach(function (b) {
      var on = b.getAttribute('data-kwh-tab') === name;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      if (on) {
        $('[data-kwh-mtitle]', m).textContent = b.getAttribute('data-title') || '';
        var sub = $('[data-kwh-msub]', m);
        sub.textContent = b.getAttribute('data-sub') || '';
        sub.hidden = !sub.textContent;
        if (focus) b.focus();
      }
    });
    $$('[data-kwh-pane]', m).forEach(function (p) { p.hidden = p.getAttribute('data-kwh-pane') !== name; });
    var body = $('[data-kwh-body]', m);
    if (body) body.scrollTop = 0;
  }
  function guards(m) {
    var panel = $('[data-kwh-panel]', m);
    if (!panel || $('[data-kwh-guard]', panel)) return;
    ['start', 'end'].forEach(function (pos) {
      var g = doc.createElement('span');
      g.tabIndex = 0;
      g.setAttribute('data-kwh-guard', pos);
      g.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;outline:0';
      if (pos === 'start') panel.insertBefore(g, panel.firstChild); else panel.appendChild(g);
      g.addEventListener('focus', function () {
        var f = $$('a[href],button:not([disabled])', panel).filter(function (el) { return el.offsetParent !== null && el.tabIndex !== -1; });
        if (!f.length) return;
        (pos === 'end' ? f[0] : f[f.length - 1]).focus();
      });
    });
  }
  function openModal(tab, from) {
    var m = modal(), l = layer('guest');
    if (!m || !l) return false;
    if (!m.classList.contains(ON)) opener = from || doc.activeElement;
    guards(m);
    m.classList.add(ON);
    m.setAttribute('aria-hidden', 'false');
    var sc = $('[data-kwh-scrim]', l);
    if (sc) sc.classList.add(ON);
    html.classList.add('kwh-lock');
    setTab(tab === 'login' ? 'login' : 'apply', false);
    guestBar();
    setTimeout(function () {
      var target = tab === 'login' ? $('[data-kwh-login]', m) : $('[data-kwh-tab][aria-selected="true"]', m);
      if (target) target.focus({ preventScroll: true });
    }, 60);
    return true;
  }
  function closeModal() {
    var m = modal(), l = layer('guest');
    if (!m || !m.classList.contains(ON)) return;
    m.classList.remove(ON);
    m.setAttribute('aria-hidden', 'true');
    var sc = l && $('[data-kwh-scrim]', l);
    if (sc) sc.classList.remove(ON);
    html.classList.remove('kwh-lock');
    guestBar();
    if (opener && opener.isConnected && opener.offsetParent !== null) opener.focus();
    if (/^#(apply|login)$/.test(location.hash) && history.replaceState) history.replaceState(null, '', location.pathname + location.search);
  }
  function markFields() {
    var wrap = $('[data-kwh-form]'), host = wrap && $('[data-forms-id]', wrap);
    if (!host) return;
    var clean = function (t) { return String(t).replace(/[\s*:]+$/, '').replace(/\s+/g, ' ').trim().toLowerCase(); };
    var required = (wrap.getAttribute('data-required') || '').split(/<br\s*\/?>/i).map(clean).filter(Boolean);
    var word = (wrap.getAttribute('data-required-word') || '').trim().toLowerCase();
    if (!required.length) return;
    var styled = false;
    function baseLabel(el) {
      if (!el.hasAttribute('data-kwh-label')) {
        var t = '';
        el.childNodes.forEach(function (n) { if (n.nodeType === 3) t += n.textContent; });
        if (!t.trim()) t = el.textContent;
        el.setAttribute('data-kwh-label', t.replace(/\s+/g, ' ').trim());
      }
      return el.getAttribute('data-kwh-label');
    }
    function decorate() {
      var embed = host.firstElementChild, shadow = embed && embed.shadowRoot;
      if (!shadow) return false;
      if (!styled) {
        var st = doc.createElement('style');
        st.textContent = '.kwh-req{color:#C8442B;font-weight:700;margin-left:3px}label.kwh-marked{white-space:nowrap}';
        shadow.appendChild(st);
        styled = true;
      }
      var labels = shadow.querySelectorAll('label, p[class*="_label_"]');
      labels.forEach(function (lab) {
        if (lab.querySelector('.kwh-req')) return;
        var text = clean(baseLabel(lab));
        if (!text || required.indexOf(text) < 0) return;
        var mark = doc.createElement('span');
        mark.setAttribute('aria-hidden', 'true');
        mark.className = 'kwh-req';
        mark.textContent = '*';
        if (word) lab.setAttribute('aria-label', baseLabel(lab) + ' (' + word + ')');
        lab.classList.add('kwh-marked');
        lab.appendChild(mark);
      });
      return labels.length > 0;
    }
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (decorate() || tries > 40) {
        clearInterval(poll);
        var embed = host.firstElementChild;
        if (embed && embed.shadowRoot) new MutationObserver(function () { decorate(); }).observe(embed.shadowRoot, { childList: true, subtree: true });
      }
    }, 250);
    polls.push(poll);
  }

  function guestBar() {
    var bar = $('[data-kwh-gbar]');
    if (bar) bar.classList.toggle(ON, heroPast && !endReached && !modalOpen());
  }
  function watch() {
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
    var bar = $('[data-kwh-gbar]');
    if (!bar) return;
    var hero = $('[data-kwh-hero-cta]'), end = $('[data-kwh-end]');
    heroPast = !hero;
    endReached = false;
    if (!('IntersectionObserver' in window)) { heroPast = true; guestBar(); return; }
    if (hero) {
      var a = new IntersectionObserver(function (es) {
        var e = es[es.length - 1];
        heroPast = !e.isIntersecting && e.boundingClientRect.top < window.innerHeight / 2;
        guestBar();
      });
      a.observe(hero);
      observers.push(a);
    }
    if (end) {
      var b = new IntersectionObserver(function (es) {
        var e = es[es.length - 1];
        endReached = e.isIntersecting || e.boundingClientRect.top < window.innerHeight / 2;
        guestBar();
      });
      b.observe(end);
      observers.push(b);
    }
    guestBar();
  }

  function orderRoot(el) { return el.closest('[data-kwh-order]'); }
  function selected(row) { return $('[data-kwh-opt][aria-checked="true"]', row); }
  function pick(row, opt) {
    $$('[data-kwh-opt]', row).forEach(function (o) {
      var on = o === opt;
      o.setAttribute('aria-checked', on ? 'true' : 'false');
      o.tabIndex = on ? 0 : -1;
    });
  }
  function initRows() {
    $$('[data-kwh-row]').forEach(function (row) {
      var root = orderRoot(row), addBtn = $('[data-kwh-add]', row);
      var opts = $$('[data-kwh-opt]', row), open = opts.filter(function (o) { return !o.disabled; });
      var cur = selected(row);
      if (cur && cur.disabled) cur = null;
      if (!cur) {
        var want = (row.getAttribute('data-default') || '').toLowerCase().trim();
        cur = open.filter(function (o) {
          return want && (o.getAttribute('data-units') === want || (o.getAttribute('data-label') || '').toLowerCase() === want);
        })[0] || open[0] || null;
      }
      if (cur) pick(row, cur);
      else if (addBtn && root) { addBtn.disabled = true; addBtn.textContent = root.getAttribute('data-t-soldout') || addBtn.textContent; }
    });
  }
  function paint() {
    if (!cart) return;
    var n = cart.item_count, l = layer('member');
    $$('[data-kwh-row]').forEach(function (row) {
      var root = orderRoot(row), parts = [];
      $$('[data-kwh-opt]', row).forEach(function (o) {
        var q = 0;
        cart.items.forEach(function (i) { if (String(i.variant_id) === o.getAttribute('data-vid')) q += i.quantity; });
        if (q) parts.push(q + ' × ' + o.getAttribute('data-label'));
      });
      row.classList.toggle('is-in', parts.length > 0);
      var box = $('[data-kwh-in]', row);
      if (box) {
        box.hidden = !parts.length;
        $('span', box).textContent = fill(root ? root.getAttribute('data-t-in') : '[list]', { list: parts.join(', ') });
      }
    });
    if (l) {
      var bar = $('[data-kwh-obar]', l);
      $$('[data-kwh-total]', l).forEach(function (e) { e.textContent = money(cart.total_price); });
      $$('[data-kwh-count]', l).forEach(function (e) {
        e.textContent = n === 1 ? l.getAttribute('data-count-one') : fill(l.getAttribute('data-count-many'), { count: n });
      });
      if (bar) bar.classList.toggle(ON, n > 0);
      doc.body.classList.toggle('kwh-has-obar', !!bar && n > 0);
    }
    var hdr = doc.getElementById('kc-hdr-cart-count');
    if (hdr) { hdr.textContent = n; hdr.hidden = !n; }
  }
  function refresh() {
    var mine = ++seq;
    return request('cart.js').then(function (c) {
      if (mine !== seq) return c;
      cart = c;
      paint();
      doc.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c, source: 'kc-wh' } }));
      return c;
    });
  }
  function fail(err, fallback) {
    toast((err && err.shop && err.description) || fallback);
  }
  function add(items, message, btn, added, error) {
    if (btn) btn.disabled = true;
    return request('cart/add.js', { items: items }).then(function () {
      if (btn) btn.disabled = false;
      toast(message);
      flash(btn, added);
      return refresh().catch(function () {});
    }, function (err) {
      if (btn) btn.disabled = false;
      fail(err, error);
    });
  }
  function addAll(btn) {
    var items;
    try { items = JSON.parse(btn.getAttribute('data-items')); } catch (e) { items = []; }
    if (!items.length) return;
    btn.disabled = true;
    request('cart/add.js', { items: items }).then(function () { return items.length; }, function (err) {
      if (items.length < 2) throw err;
      var done = 0;
      return items.reduce(function (chain, item) {
        return chain.then(function () {
          return request('cart/add.js', { items: [item] }).then(function () { done++; }, function () {});
        });
      }, Promise.resolve()).then(function () {
        if (!done) throw err;
        return done;
      });
    }).then(function (done) {
      btn.disabled = false;
      toast(done === items.length ? btn.getAttribute('data-toast') : fill(btn.getAttribute('data-partial'), { n: done, total: items.length }));
      flash(btn, btn.getAttribute('data-added'));
      return refresh().catch(function () {});
    }).catch(function (err) {
      btn.disabled = false;
      fail(err, btn.getAttribute('data-error'));
    });
  }
  function clearRow(row, btn) {
    var updates = {}, root = orderRoot(row), any = false;
    $$('[data-kwh-opt]', row).forEach(function (o) {
      var id = o.getAttribute('data-vid');
      if (cart && cart.items.some(function (i) { return String(i.variant_id) === id; })) { updates[id] = 0; any = true; }
    });
    if (!any) return Promise.resolve();
    if (btn) btn.disabled = true;
    return request('cart/update.js', { updates: updates }).then(refresh).then(function () {
      if (btn) btn.disabled = false;
      var a = $('[data-kwh-add]', row);
      if (a) a.focus();
    }).catch(function (err) {
      if (btn) btn.disabled = false;
      fail(err, root && root.getAttribute('data-t-error'));
    });
  }

  function shelf(root, cents) {
    var unit = parseInt(root.getAttribute('data-unit'), 10) || 0;
    if (!unit || !cents) return;
    var keep = cents - unit;
    $$('[data-k]', root).forEach(function (el) {
      var k = el.getAttribute('data-k'), n = parseInt(el.getAttribute('data-n'), 10) || 0;
      if (k === 'keep') el.textContent = money(keep);
      else if (k === 'margin') el.textContent = (keep / cents * 100).toFixed(1) + '%';
      else if (k === 'cover') el.textContent = Math.ceil(n * unit / cents);
      else if (k === 'all') el.textContent = money(keep * n);
    });
  }
  function initCalc() {
    $$('[data-kwh-calc]').forEach(function (root) {
      var cur = $('[data-kwh-shelf][aria-checked="true"]', root) || $('[data-kwh-shelf]', root);
      if (!cur) return;
      cur.setAttribute('aria-checked', 'true');
      cur.tabIndex = 0;
      shelf(root, parseInt(cur.getAttribute('data-kwh-shelf'), 10));
    });
  }

  function route() {
    if (location.hash === '#apply') openModal('apply', null);
    else if (location.hash === '#login') openModal('login', null);
  }
  function init() {
    polls.forEach(clearInterval);
    polls = [];
    if (!modal()) html.classList.remove('kwh-lock');
    toastHost();
    watch();
    markFields();
    initRows();
    initCalc();
    if (layer('member') || $('[data-kwh-row]')) refresh().catch(function () {});
    route();
  }

  doc.addEventListener('click', function (e) {
    if (e.target.matches && e.target.matches('[data-kwh-scrim],[data-kwh-modal]')) {
      if (downOnBackdrop) closeModal();
      return;
    }
    var t = e.target.closest && e.target.closest('a,button');
    if (!t) return;
    var plain = !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) && e.button === 0;
    if (t.tagName === 'A' && plain && modal() && !t.closest('[data-kwh-modal]')) {
      var l = layer('guest'), path = l && l.getAttribute('data-apply-path'), hit = t.getAttribute('data-kwh-open') === 'apply';
      if (!hit && path) {
        try {
          var u = new URL(t.href, location.href);
          hit = u.origin === location.origin && u.pathname.replace(/\/+$/, '') === path.replace(/\/+$/, '');
        } catch (err) { hit = false; }
      }
      if (hit && openModal('apply', t)) { e.preventDefault(); return; }
    }
    if (!t.closest('.kwh')) return;
    if (t.matches('[data-kwh-close]')) { closeModal(); return; }
    if (t.matches('[data-kwh-tab]')) { setTab(t.getAttribute('data-kwh-tab'), true); return; }
    if (t.matches('[data-kwh-more]')) {
      var card = t.closest('.kwh-pcard'), open = t.getAttribute('aria-expanded') !== 'true';
      var group = t.closest('[data-kwh-formulas]');
      var cards = group && window.matchMedia('(min-width:700px)').matches ? $$('.kwh-pcard', group) : [card];
      cards.forEach(function (c) {
        var b = $('[data-kwh-more]', c);
        if (!b) return;
        c.classList.toggle('is-closed', !open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      return;
    }
    if (t.matches('[data-kwh-again]')) { addAll(t); return; }
    if (t.matches('[data-kwh-shelf]')) {
      var calc = t.closest('[data-kwh-calc]');
      $$('[data-kwh-shelf]', calc).forEach(function (b) {
        var on = b === t;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      shelf(calc, parseInt(t.getAttribute('data-kwh-shelf'), 10));
      return;
    }
    var row = t.closest('[data-kwh-row]');
    if (row) {
      var root = orderRoot(row);
      if (t.matches('[data-kwh-opt]')) { pick(row, t); return; }
      if (t.matches('[data-kwh-add]')) {
        var o = selected(row);
        if (!o) return;
        var name = row.getAttribute('data-name') + ' ' + o.getAttribute('data-label');
        add([{ id: parseInt(o.getAttribute('data-vid'), 10), quantity: 1 }], fill(root.getAttribute('data-t-toast'), { name: name }), t, root.getAttribute('data-t-added'), root.getAttribute('data-t-error'));
        return;
      }
      if (t.matches('[data-kwh-clear]')) clearRow(row, t);
    }
  });
  doc.addEventListener('mousedown', function (e) {
    downOnBackdrop = !!(e.target.matches && e.target.matches('[data-kwh-scrim],[data-kwh-modal]'));
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModal(); return; }
    var keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'];
    if (keys.indexOf(e.key) < 0 || !e.target.closest) return;
    var group = e.target.closest('.kwh [role="radiogroup"],.kwh [role="tablist"]');
    if (!group) return;
    var set = $$('[role="radio"],[role="tab"]', group).filter(function (r) { return !r.disabled; });
    var i = set.indexOf(e.target);
    if (i < 0) return;
    e.preventDefault();
    var next = set[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + set.length) % set.length];
    next.click();
    next.focus();
  });
  window.addEventListener('hashchange', route);
  doc.addEventListener('shopify:section:load', init);
  doc.addEventListener('shopify:section:select', function (e) {
    var l = layer('guest');
    if (l && e.detail && l.getAttribute('data-section') === e.detail.sectionId) openModal('apply', null);
  });
  doc.addEventListener('shopify:section:deselect', function (e) {
    var l = layer('guest');
    if (l && e.detail && l.getAttribute('data-section') === e.detail.sectionId) closeModal();
  });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
